export const formatNumber = (num) => {
  return Number(num).toLocaleString();
};